import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';

import SingleSignOnLogoutForm from '../../containers/Login/SingleSignOnLogoutForm';
import { setIsDedicatedWorkflow } from '../../redux/modules/workflow/workflow-action-creator';


class SingleSignOnLogoutPage extends Component {
  UNSAFE_componentWillMount = () => {
    this.props.dispatch(setIsDedicatedWorkflow(false));
  }

  render() {
    return (
      <div>
        <SingleSignOnLogoutForm />
      </div>
    );
  }
}

SingleSignOnLogoutPage.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) => ({
  token: state.token,
  location: ownProps.location,
});

export default connect(mapStateToProps)(SingleSignOnLogoutPage);